import { useAccountInfo } from '@vs/hooks/hook-account-info';
import { useUserAvatarGetQuery } from '@vs/rtk/slices/apiVsAccount2';
import { defaultAvatarPath } from '@vs/utils/constants';

type supportedSize = { width: 150; height: 150 } | { width: 48; height: 48 };

export const useAvatarUrl = (opts: {
  size: supportedSize;
  assetsOrigin?: string;
}): string => {
  const { size, assetsOrigin = '' } = opts;
  const { data: accountInfo } = useAccountInfo();
  const accountId = accountInfo?.id ?? '';
  const { data: avatar } = useUserAvatarGetQuery(
    {
      accountId,
    },
    { skip: !accountId }
  );
  const url = (() => {
    if (avatar) {
      const { avatar_url } = avatar;
      const url = avatar_url.startsWith('http')
        ? avatar_url
        : `${assetsOrigin}${avatar_url.startsWith('/') ? avatar_url : `/${avatar_url}`}`;
      return `${url}${avatar.modify_time ? `?mt=${new Date(avatar.modify_time).getTime()}` : ''}`;
    }
    return `${assetsOrigin}${defaultAvatarPath}`;
  })();

  return url.replace('_48x48', `_${size.width}x${size.height}`);
};

export default useAvatarUrl;
